<template>
  <div>
    <footer>
      <div class="container-fluid" v-if="footerData">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-6">
            <h5>Quick Link</h5>
            <ul>
              <li
                v-for="qLink in footerData.blockLinks[0].links"
                :key="qLink.name"
                @click="(e) => handleClick(qLink.alias, e)"
              >
                {{ qLink.name }}
              </li>
              <!-- <router-link :to="quickLinkUrl(qLink.alias)"   >{{qLink.name}}</router-link> -->
              <!-- <li><a href="#"> Employer Register</a></li>
              <li><a href="#"> Employer Login </a></li>
              <li><a href="#"> Hire Staff </a></li>
              <li><a href="#"> Hiring Plans</a></li>
              <li><a href="#"> Database Plans</a></li>
              <li><a href="#"> Job Posting Plans</a></li>
              <li><a href="#"> Consultant Plans</a></li>
              <li><a href="#"> Contact us</a></li>
              <li><a href="#"> Sales Enquiry</a></li> -->
            </ul>
          </div>

          <div class="col-md-2 col-sm-2 col-xs-6">
            <h5>Post Jobs By City</h5>
            <ul>
              <li v-for="city in footerData.blockLinks[1].links" :key="city.name">
                <router-link :to="'/' + city.alias" replace>{{ city.name }}</router-link>
              </li>
              <!-- <li><a href="#"> Noida</a></li>
              <li><a href="#">Gurgaon</a></li>
              <li><a href="#">Mumbai</a></li>
              <li><a href="#">Bangalore</a></li>
              <li><a href="#">Pune</a></li>
              <li><a href="#">Hyderabad</a></li>
              <li><a href="#">Chennai</a></li>
              <li><a href="#">Ahmedabad</a></li>
              <li><a href="#">Jaipur</a></li> -->
            </ul>
          </div>

          <div class="col-md-3 col-sm-3 col-xs-6">
            <h5>Hire Employee</h5>
            <ul>
              <li v-for="hireEmp in footerData.blockLinks[2].links" :key="hireEmp.name">
                <a :href="hireEmp.alias" target="_blank">{{ hireEmp.name }}</a>
              </li>
              <!-- <router-link :to="'/'+hireEmp.alias" replace>{{hireEmp.name}}</router-link> -->
              <!-- <li><a href="#"> Hire Digital Marketing Staff </a></li>
              <li><a href="#">Hire Designing Staff</a></li>
              <li><a href="#"> Hire Receptionist Staff </a></li>

              <li><a href="#"> Hire Education Counselor Staff </a></li>
              <li><a href="#"> Hire Hr Executive Staff</a></li>
              <li><a href="#"> Hire Personal Assistant Staff</a></li>
              <li><a href="#"> Hire Marketing Executive Staff</a></li>
              <li><a href="#"> Hire Telemarketing Staff</a></li> -->
            </ul>
          </div>

          <div class="col-md-2 col-sm-2 col-xs-6">
            <h5>Hire Staff/Worker</h5>
            <ul>
              <li v-for="worker in footerData.blockLinks[3].links" :key="worker.name">
                <a :href="worker.alias" target="_blank">{{ worker.name }}</a>
              </li>
              <!-- <router-link :to="'/'+worker.alias" replace>{{worker.name}}</router-link> -->
              <!-- <li><a href="#"> Hire Production staff </a></li>
              <li><a href="#"> Hire Construction Staff</a></li>
              <li><a href="#"> Hire Maintenance staff</a></li>
              <li><a href="#">Hire Technician staff</a></li>
              <li><a href="#"> Hire Cook Chef Staffs</a></li>
              <li><a href="#"> Hire Delivery Workers</a></li>
              <li><a href="#">Hire Labor/Workers</a></li>
              <li><a href="#">Hire Machine Operator</a></li>
              <li><a href="#">Hire Welder</a></li> -->
            </ul>
          </div>

          <div class="col-md-3 col-sm-3 col-xs-6">
            <h5>Your Query</h5>

            <!-- <form> -->
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="Name1"
                placeholder="Your Name"
                onkeypress="return /[a-z- ]/i.test(event.key)"
                v-model="contactDetail.name"
              />
            </div>
            <div class="form-group">
              <input
                type="email"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Your E-mail"
                v-model="contactDetail.email"
              />
            </div>
            <div class="form-group">
              <input
                type="number"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Phone Number"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                maxlength="10"
                v-model="contactDetail.contact"
              />
            </div>

            <div class="form-group">
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                placeholder="Your Message"
                rows="3"
                v-model="contactDetail.msg"
              ></textarea>
            </div>
            <button
              type="submit"
              class="btn other-profile"
              @click="onSubmit"
              :disabled="isSubmit"
              v-if="isSubmit"
            >
              Submiting <b-spinner label="Loading..."></b-spinner>
            </button>
            <button
              type="submit"
              v-else
              class="btn other-profile"
              @click="onSubmit"
              :disabled="isSubmit"
            >
              Submit
            </button>
            <!-- </form> -->
          </div>
        </div>
      </div>
    </footer>
    <div id="login-modal">
      <LoginModal
        v-if="showLoginModal"
        :showModal="showLoginModal"
        @close="showLoginModal = false"
        @change-route="changeRoute"
      />
    </div>
    <div class="steacky">
      <div class="text-center connect">
        <h5>Connect with Us</h5>

        <ul class="list-inline social-links">
          <li class="social-1">
            <a class="facebook" href="https://www.facebook.com/TheIncircle" target="_blank">
              <i class="fa fa-facebook" aria-hidden="true"></i>
            </a>
          </li>
          <li class="social-1">
            <a class="twitter" href="https://twitter.com/theincircle" target="_blank">
              <i class="fa fa-twitter" aria-hidden="true"></i>
            </a>
          </li>

          <li class="social-1">
            <a
              class="linkedin"
              href="https://www.linkedin.com/company/the-incircle"
              target="_blank"
            >
              <i class="fa fa-linkedin" aria-hidden="true"></i>
            </a>
          </li>

          <li class="social-1">
            <a class="insta" href="https://www.instagram.com/theincirclejobs" target="_blank">
              <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>
          </li>
          <li class="social-1">
            <a class="pinterest" href="https://www.youtube.com/c/TheIncircle" target="_blank">
              <i class="fa fa-youtube-play" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-link text-center">
        <a href="/aboutus"> About Us </a>
        |
        <router-link to="/contact-us"> Contact Us </router-link>
        <a href="https://www.theincircle.com/faq" target="_blank"> FAQ </a> |
        <a href="https://www.theincircle.com/help" target="_blank"> Help </a>|
        <a href="https://www.theincircle.com/privacy" target="_blank"> Privacy Policy </a>
        |
        <a href="https://www.theincircle.com/terms" target="_blank"> Terms </a>
      </div>
      <div class="footer-note text-center">
        © 2024 TAGGER TECHNOLOGIES LLP, All Rights Reserved.
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoginModal from '@/components/Modal/LoginModal.vue'
/* eslint-disable */
export default {
  name: 'Footer',
  components: {
    LoginModal
  },
  data() {
    return {
      showLoginModal: false,
      footerData: null,
      isSubmit: false,
      contactDetail: {
        name: '',
        email: '',
        contact: '',
        msg: ''
      }
    }
  },
  computed: {
    ...mapState({
      getfooter: (state) => state.EmployerModule.footerData,
      contactUs: (state) => state.GeneralModule.contactUs
    })
  },
  watch: {
    getfooter() {
      if (!this.getfooter.isFetchingFooter) {
        if (this.getfooter.responseData.status === 200) {
          this.footerData = this.getfooter.responseData.data.footer
        }
      }
    },
    contactUs() {
      if (!this.contactUs.isSendingContactus) {
        this.isSubmit = false
        this.$message({
          message: this.contactUs.responseData.data.message,
          type: 'success',
          offset: 80
        })
        this.$router.push('/thank-you')
        this.contactDetail = {
          name: '',
          email: '',
          contact: '',
          msg: ''
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch('EmployerModule/actionGetFooter', this.contactDetail)
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  methods: {
    changeRoute() {
      if (this.prevRoute && this.prevRoute.path && this.prevRoute.path !== '/') {
        this.$router.push(this.prevRoute.path)
      } else {
        this.$router.push('/dashboard')
      }
    },
    onSubmit() {
      let regex = new RegExp(`[a-z0-9]+@[a-z]+\\.[a-z]{2,3}`)
      let { name, email, contact, msg } = this.contactDetail
      if (name && regex.test(email) && contact && msg) {
        this.isSubmit = true
        this.$store.dispatch('GeneralModule/actionSubmitContactUs', this.contactDetail)
      } else {
        this.$message({
          message: 'Please fill all required details correctly!!!',
          type: 'error',
          offset: 80
        })
      }
    },
    quickLinkUrl(aliasName) {
      if (aliasName === 'Employer Login') {
        return '/'
      }
      return '/' + aliasName
    },
    handleClick(aliasName) {
      if (aliasName === '/') {
        // this.showLoginModal = true;
        this.$router.replace({ path: '/' })
      } else if (aliasName === 'enquiry') {
        this.$router.replace({ path: '/comming-soon' })
      } else {
        this.$router.replace({ path: '/' + aliasName })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"
>
.form-group {
  margin-bottom: 1rem;
}

footer ul li:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #0056b3;
}
a {
 
  text-decoration: none;
  background-color: transparent;
}



a:hover {
  color: #0056b3;
  text-decoration: underline;
}
</style>
